/* eslint-disable */
import React, { FC, useEffect } from 'react';
import { Spin } from 'antd';
import { useHistory } from 'react-router';
import { useGetApplication } from '~/controllers/wizard';
import WizardContent from '~/layouts/WizardContent';
import ApplicationNavigation from '~/layouts/uae/ApplicationNavigation';
import DataValidation from '~/pages/ksa/dataValidation/DataValidation';
import paths from '~/pages/paths';
import { getStagePayload } from '~/utils/getStagePayload';
import { handleGetutm } from '~/utils/handleGetUtm';
import ApplicationSummary from '~/components/ApplicationSummary';
import styled from 'styled-components';

/**
 * InitialInformation page — Step 2 in the new KSA flow.
 *
 * Routing is fully backend-driven via activeStep.key:
 *  - activeStep.key === 'initialInformation'  → render DataValidation form (we are here)
 *  - activeStep.key === 'services'            → redirect back to Select Products (step 1)
 *  - activeStep.key starts with 'application' → redirect to Business Information (step 3)
 */
const InitialInformation: FC = () => {
  const applicationQuery = useGetApplication();
  const history = useHistory();

  const data = applicationQuery?.data;
  const stagePayload = getStagePayload.wizard(data);
  const activeStepKey = stagePayload?.activeStep?.key;
  const utmParams = handleGetutm(data);

  useEffect(() => {
    if (applicationQuery.isLoading) return;

    // Guard: if backend says user should be selecting products → send back to step 1
    if (activeStepKey === 'services') {
      history.replace(`${paths.ksa.services}?${utmParams}`);
      return;
    }

    // If backend says user has completed Initial Information → go to Business Information
    if (activeStepKey?.startsWith('application')) {
      history.replace(`${paths.ksa.application}?${utmParams}`);
    }
  }, [activeStepKey, applicationQuery.isLoading]);

  if (applicationQuery.isLoading) return <Spin />;

  return (
    <WizardContent
      left={<ApplicationNavigation />}
      content={<DataValidation />}
      right={
        <RightContainer>
          <ApplicationSummary />
        </RightContainer>
      }
    />
  );
};

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;

  .upperContainer {
    height: 100%;
  }
`;

export default InitialInformation;
